// extracted by mini-css-extract-plugin
export default {"cls1":"iDaCmVOmHfViiT93_vE0","cls2":"hK8lha8zJ1UvU8E2Rm8H iDaCmVOmHfViiT93_vE0"};